import React from 'react';
import { useParams } from 'react-router-dom';

import ModelTimeline from '@dashboard/components/ModelTimeline';
import { Grid } from '@mui/material';

import AdministratorActions from './AdministratorActions';
import Navigation from './Navigation';
import WaypointEventBody from './WaypointEventBody';

export default function WaypointEventShow() {
  const id = useParams<{ id: string }>().id!;
  return (
    <Grid container spacing={3}>
      <Grid item xs={12} lg={1}>
        <Navigation />
      </Grid>

      <Grid item xs={12} md={7} lg={7}>
        <WaypointEventBody waypointEventId={id} />
      </Grid>
      <Grid item xs={12} md={5} lg={4}>
        <AdministratorActions id={id} />
        <ModelTimeline parentModelId={id} parentModelType="EmailMessage" />
      </Grid>
    </Grid>
  );
}
